import { useEffect } from "react";
import api from "../api";
import { useRootSelector } from "../hooks/useAppSelector";
const updateInterval = 60 * 1000;
const updateHeartBeat = (isLogged) => {
    if (!isLogged)
        return;
    api.updateHeartBeat();
};
export const useHeartBeat = () => {
    const { isLogged } = useRootSelector();
    useEffect(() => {
        const interval = setInterval(() => updateHeartBeat(isLogged), updateInterval);
        return () => clearInterval(interval);
    }, [isLogged]);
};
